// 日语(Japanese)
export default {
  oneOneClass: "",
  learnPracEnFast: "",
  htOralClass: "",
  benefits: "",
  topicNumber: "",
  dailyBusinessAcademic: "",
  englishTutors: "",
  qualifiedTutors: "",
  nativeOkAllAges: "",
  oneOneLive: "",
  accessToRecord: "",
  personalizedPlan: "",
  ensureGoal: "",
  professional: "",
  nativeTeam: "",
  authenticLanguage: "",
  bgChecked: "",
  experiencedTeachers: "",
  assuredQuality: "",
  regularAssess: "",
  assuredSatisfaction: "",
  teamSizeAndRefund: "",
  curriculum: "",
  dailyTalks: "",
  beginnerInfo: "",
  lessonOverview: "",
  beginnerClassIntro: "",
  topicEx: "",
  beginnerTopicEx: "",
  mediateInfo: "",
  mediateClassIntro: "",
  mediateTopicEx: "",
  advancedInfo: "",
  advancedClassIntro: "",
  advancedTopicEx: "",
  businessLanguage: "",
  busElementInfo: "",
  busElementClassIntro: "",
  busElementTopicEx: "",
  busMediateInfo: "",
  busMediateClassIntro: "",
  busMediateTopicEx: "",
  ielts: "",
  languageTests: "",
  aHundredLessons: "",
  ieltsClassIntro: "",
  faq: "",
  questionCn: "",
  classLength: "",
  classInfoAndSuggest: "",
  lessonForm: "",
  lessonFormInfo: "",
  lessonPrepare: "",
  lessonPrepareInfo: "",
  support: "",
  limitedOffer: "",
  originalPrice: "",
  bookNow: "",
  successPurchase: "",
  trialEndAndGoOn: "",
  courseAdvisor: "",
  oneLastStep: "",
  ticketPrice: "",
  perPriceAndOrder: "",
  noThanks: "",
  unpaidAndProceed: "",
  halfPrice: "",
  languageEn: "",
  languageKo: "",
  languageEsp: "",
  languageFr: "",
  languageIt: "",
  languageRu: "",
  languageCn: "",
  languageJp: "",
  courseEn: "",
  courseKo: "",
  courseEsp: "",
  courseFr: "",
  courseIt: "",
  courseRu: "",
  courseCn: "",
  courseJp: "",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  coinSpecialOffer: "HTコイン補充特別オファー",
  buySomeAndGetExtra: "購入しておまけをもらおう！",
  balance: "残高",
  coins: "{number}コイン",
  coin: "{number}コイン",
  extraCoins: "{number}追加コイン",
  continue: "選択",
  byToppingUpYouAgree: "補充すると契約に同意したこととなります",
  topUpAgreement: "[補充に関する契約]",
  htCoin: "HTコイン",
  scanCodeToLog: "コードをスキャンしてログイン",
  bindYourHelloTalkAccount:
    "HelloTalkアプリでコードをスキャンし、ログインします。HelloTalkアカウントを連携し、補充します。",
  itemSelection: "項目選択",
  paymentAmount: "支払い金額",
  topUpSuccessful: "補充に成功👏",
  totalCoinsNumber:
    "{numberone}コインの補充に成功し、{numbertwo}追加コインを受け取りました。合計 {numberall}コインです。",
  ok: "OK",
  copyLinkToPay:
    "リンクをコピーして、HelloTalkアプリで開き、決済を完了してください。",
  paymentFailed: "お支払いに失敗しました",
  creditCardPay: "PayPalまたはクレジットカードで支払う",
  creditCard: "クレジットカード",
};
